import React from 'react';
import './Parking.css';
import FMSimage from '../Assets/parking1.png'; // First image (full size)
import FMSimage2 from '../Assets/Parking2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/parking3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/parking4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/parking5.webp'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">PARKING MANAGEMENT</h1>
                    <p className="FMS-description">
                        Vajra IoT's Parking Management System is an advanced solution designed to streamline parking operations, reduce congestion, and improve the overall parking experience. By leveraging IoT technology, this system offers real-time monitoring, efficient space allocation, and seamless payment integration to make parking smarter and more user-friendly.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Parking Management" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Real-Time Parking Availability:</strong> Get live updates on available parking spaces to minimize time spent searching.</li>
                            <li><strong>Automated Space Allocation:</strong> Optimize parking space usage with automated assignments based on vehicle type and availability.</li>
                            <li><strong>Contactless Payments:</strong> Integrate cashless payment options for a seamless parking experience.</li>
                            <li><strong>Smart Security:</strong> Use surveillance systems and automated alerts to enhance safety and reduce unauthorized access.</li>
                            <li><strong>Customizable Reports:</strong> Generate detailed reports on parking usage, revenues, and operational efficiency.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Sensor Integration:</strong> IoT sensors monitor parking spaces to provide real-time availability updates.</li>
                            <li><strong>Centralized Control:</strong> A web-based platform manages parking reservations, payments, and security systems.</li>
                            <li><strong>License Plate Recognition:</strong> Use AI-driven cameras for seamless entry and exit without manual intervention.</li>
                            <li><strong>Mobile App Integration:</strong> Drivers can check availability, reserve spots, and make payments through a user-friendly app.</li>
                            <li><strong>Data Analytics:</strong> Analyze parking patterns to improve operations and forecast future demand.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Parking Management</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Efficiency:</strong> Reduce congestion and improve user satisfaction with real-time monitoring and automated operations.</li>
                            <li><strong>Cost-Effective:</strong> Optimize space utilization to maximize revenue while minimizing operational costs.</li>
                            <li><strong>Enhanced Security:</strong> Advanced surveillance systems ensure safety for both vehicles and users.</li>
                            <li><strong>Customizable Solutions:</strong> Tailor the system to suit specific parking requirements and environments.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FMS */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Parking Management System is trusted across various sectors for its reliability, efficiency, and ease of use:
                        <ul>
                            <li>Commercial Complexes</li>
                            <li>Residential Societies</li>
                            <li>Shopping Malls</li>
                            <li>Airports & Railway Stations</li>
                            <li>Smart Cities</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FMS;
